/* eslint import/prefer-default-export: 0 */
import * as t from './action_types';

export const setSelectedView = (viewName, view) => ({
  type: t.SET_SELECTED_VIEW,
  payload: { view, viewName },
});
